<template>
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A9 9 0 0 0 11.25 3.75h-1.5a9 9 0 0 0-4.125-.281V3.375c0-1.036.84-1.875 1.875-1.875h.75c.621 0 1.125.504 1.125 1.125v.621A8.94 8.94 0 0 0 9 4.125c-.621 0-1.125.504-1.125 1.125v.621A8.96 8.96 0 0 0 8.25 6.75v8.625c0 .621.504 1.125 1.125 1.125h6.75c.621 0 1.125-.504 1.125-1.125V12a7.501 7.501 0 0 0-7.5-7.5H7.5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5 2.25H5.625C4.589 2.25 3.75 3.089 3.75 4.125v17.25c0 1.036.84 1.875 1.875 1.875h12.75c1.036 0 1.875-.84 1.875-1.875V12.75a9 9 0 0 0-9-9V2.25Zm2.25 8.625a.75.75 0 0 1 .75-.75c4.142 0 7.5 3.358 7.5 7.5a.75.75 0 0 1-1.5 0 6 6 0 0 0-6-6 .75.75 0 0 1-.75-.75ZM7.5 15.75a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H8.25Z"
    />
  </svg>
</template>
<script>
export default { name: 'IconClaimsFilled' }
</script>
